import React, { Component } from "react";
import { PieChart, Pie, Cell, Legend, Tooltip } from "recharts";
import { get } from "lodash-es";
import styled from "styled-components";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";

const LegendList = styled.ul`
  list-style-type: none;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  /* background: rgba(0, 0, 0, 0.01); */
`;
const LegendItem = styled.li`
  padding: 1px;
  ${props => props.legendItemCss };
  ${props => props.active && "background: rgba(0,0,0,.05);"}
`;

const LegendSvg = ({ cor }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 32 32"
    version="1.1"
    style={{
      display: "inline-block",
      verticalAlign: "middle",
      marginRight: "4px"
    }}
  >
    <path stroke="none" fill={cor} d="M0,4h32v24h-32z" />
  </svg>
);

class LegendCustom extends Component {
  onMouseEnter = o => this.props.onMouseEnter(o);
  onMouseLeave = o => this.props.onMouseLeave(o);
  render() {
    const { payload, selected, onMouseEnter, onMouseLeave, legendItemCss } = this.props;
    return (
      <LegendList>
        {payload.map((el, i) => (
          <LegendItem
            key={`item-${i}`}
            active={selected && el.payload.Id === selected.Id}
            onMouseEnter={() => onMouseEnter(el)}
            onMouseLeave={() => onMouseLeave(el)}
            legendItemCss={legendItemCss}
          >
            <LegendSvg cor={el.color} />
            {el.value}
          </LegendItem>
        ))}
      </LegendList>
    );
  }
}

const Box = styled(Paper)`
  && {
    box-sizing: border-box;
    background: rgba(0,0,0,0.5);
    color: white;  
    padding: 6px;
    font-size: 10px;
  }
`;
// const Box = styled(Paper)`
//   box-sizing: border-box;
//   padding: 6px;
//   font-size: 10px;
//   /* width: 320px; */
//   p {
//     color: ${props => props.cor};
//   }
// `;

class TooltipCustom extends Component {
  componentWillUpdate(nextProps) {
    const { payload, active } = nextProps;
    // console.log(payload)
    const { props } = this;
    const el = (active && payload && payload[0]) || false;
    const oldEl = (props.active && props.payload && props.payload[0]) || false;
    const Id = get(el, "payload.Id");
    const oldId = get(oldEl, "payload.Id");
    if (active && Id !== oldId) {
      this.props.enter(el);
    }
    if (!active && props.active) {
      this.props.leave();
    }
  }
  render() {
    const { selected } = this.props;
    if (!selected) return null;
    let { fill, name, value, pct } = selected;
    return (
      <Box>
        {name}: {value} ({pct})
      </Box>
    );
  }
}

function calculaPct(data) {
  let soma = data.reduce((state,obj) => state + obj.value, 0);
  let out = {};
  data.forEach(obj => {
    out[obj.Id] = (obj.value / soma) * 100
  })
  return out;
}

class ChartPie extends Component {
  state = { selected: null };
  percent = calculaPct(this.props.data);
  handleMouseEnter = o => {
    const { dataKey } = this.props;
    let { fill, Nome: name, Id } = o.payload;
    let value = get(o, `payload.${dataKey}`);
    // value = value.toLocaleString("pt-BR", {
    //   style: "currency",
    //   currency: "BRL"
    // });
    let pct = this.percent[o.payload.Id]
    pct = `${parseFloat(pct).toFixed(2)}%`;
    this.setState({ selected: { Id, name, value, fill, pct } });
  };
  handleMouseLeave = o => this.setState({ selected: null });
  render() {
    const { data, dataKey, width=350, height=150, legendItemCss='' } = this.props;
    const { selected } = this.state;
    const { Id } = selected || {};
    return (
      <PieChart width={width} height={height}>
        <Pie
          data={data}
          nameKey="Nome"
          dataKey={dataKey}
          cx={80}
          cy={60}
          innerRadius={40}
          outerRadius={60}
          fill="#82ca9d"
          animationDuration={800}
        >
          {data.map(cat => (
            <Cell
              fill={cat.Cor}
              fillOpacity={(selected && cat.Id !== Id && 0.5) || 1}
            />
          ))}
        </Pie>
        <Tooltip
          content={
            <TooltipCustom
              selected={selected}
              dataKey={dataKey}
              enter={this.handleMouseEnter}
              leave={this.handleMouseLeave}
            />
          }
          defaultShowTooltip
          active
          position={{ x: 30, y: 150 }}
          wrapperStyle={{ visibility: "visible" }}
        />
        <Legend
          content={<LegendCustom selected={selected} legendItemCss={legendItemCss} />}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          layout="vertical"
          align="right"
          verticalAlign="top"
        />
      </PieChart>
    );
  }
}

export default ChartPie;
